import { Link } from "react-router-dom";

export default function ComingSoonPage({
  title = "Coming soon",
  detail = "This screen needs APIs that are not on the Neron broker server yet. Click to call, users, and live line status are available now.",
}: {
  title?: string;
  detail?: string;
}) {
  return (
    <section className="panel">
      <p className="eyebrow">Neron · iPBX</p>
      <h2>{title}</h2>
      <p className="muted" style={{ maxWidth: 520 }}>
        {detail}
      </p>
      <p style={{ marginTop: 18 }}>
        <Link className="btn" to="/app/softphone">
          Open click to call
        </Link>
      </p>
    </section>
  );
}
